<template>
	<div>
		<div class="container-node-headline">
			<p>
				<span
					class="senaryon-icon senaryon-icon-metrics senaryon-icon--with-right-margin"
				></span>
				<span>
					<!-- @vue-expect-error --> {{ dataNode.data.property_name }}</span
				>
			</p>
		</div>
		<drawflow-top-right-tags
			:tags-to-show="tagsToShow"
			:modal-id="modalId"
			:parent-instance="this"
		></drawflow-top-right-tags>
		<span
			class="Tag Tag--neutral-high-contrast Tag--padding container-node-top container-node-top--left"
		>
			<span
				class="senaryon-icon senaryon-icon-algorithm senaryon-icon--with-right-margin"
			></span>
			<span class="hidden-label">
				<div>
					<strong>{{ t("activerecord.models.calculation.one") }}:</strong>
					<br>
					<span>
						<!-- @vue-expect-error -->
						{{ dataNode.data.calculation_name }}</span
					>
				</div>
				<div>
					<strong
						>{{
							t("activerecord.attributes.calculation.custom_parameters")
						}}:</strong
					>
					<br>
					<span>
						<!-- @vue-expect-error -->
						{{ dataNode.data.custom_parameter_names || "-" }}</span
					>
				</div>
			</span>
		</span>
		<drawflow-actor-property-item
			v-for="childNode in childNodes"
			v-bind:key="childNode.id"
			:data-node="childNode"
			:drawflow-instance="drawflowInstance"
		></drawflow-actor-property-item>
	</div>
</template>

<script>
import { i18n } from "../utils";
import DrawflowActorPropertyItem from "./drawflow_actor_property_item.vue";
import DrawflowHelpers from "./drawflow_helpers";
import DrawflowTopRightTags from "./drawflow_top_right_tags.vue";

export default {
	mixins: [i18n],
	props: {
		dataNode: Object,
		drawflowInstance: Object,
		modalId: {
			type: String,
			default: "#replace-me",
		},
	},
	components: {
		"drawflow-actor-property-item": DrawflowActorPropertyItem,
		"drawflow-top-right-tags": DrawflowTopRightTags,
	},
	computed: {
		tagsToShow() {
			// @ts-expect-error
			return this.drawflowInstance.editor_mode == "edit"
				? ["delete", "duplicate", "edit", "addGroup"]
				: [];
		},
	},
	data: function () {
		return {
			// @ts-expect-error
			childNodes: Object.values(this.dataNode.child_nodes),
		};
	},
	methods: {
		callPositionNode() {
			DrawflowHelpers.positionNode(this);
		},
		filterForActorIds({ whitelistedActorIds }) {
			this.childNodes.forEach((childNode) => {
				const dataDup = structuredClone(childNode.data);
				// NB `whitelistedActorIds` will be `null` if nothing has been selected
				dataDup.isCollapsed =
					whitelistedActorIds &&
					!whitelistedActorIds.includes(String(childNode.data.actor_id));
				childNode.data = dataDup;
			});
			setTimeout(() => {
				DrawflowHelpers.addToDagre(
					this.drawflowInstance,
					this.dataNode,
					this.$el.closest(".container-node"),
				);
			}, 400);
		},
	},
	mounted() {
		// pp.log("mounted drawflow_property_item", this.dataNode, this.$el);
		setTimeout(() => {
			// Move this to the end of the stack so that the $domEl can be appended to `.container-node` in drawflow.js first
			DrawflowHelpers.addToDagre(
				this.drawflowInstance,
				this.dataNode,
				this.$el.closest(".container-node"),
			);
		});

		pp.vue.bus.$on("DRAWFLOW-child-nodes-changed", (data) => {
			// @ts-expect-error
			if (data.nodeId == this.dataNode.id) {
				// pp.log("drawflow_property_item child nodes change", data, this);
				this.childNodes = []; // Need to destroy child Vue instances first

				this.$nextTick(() => {
					// @ts-expect-error
					this.childNodes = Object.values(this.dataNode.child_nodes);
				});
			}
		});

		pp.vue.bus.$on("DRAWFLOW-graph-changed", this.callPositionNode);
		pp.vue.bus.$on("DRAWFLOW-filter-actor-ids", this.filterForActorIds);
	},
	beforeDestroy() {
		pp.vue.bus.$off("DRAWFLOW-graph-changed", this.callPositionNode);
	},
};
</script>
